$( document ).ready(function( $ ) {
    // initialise plugin
    var navigation = $('#mainNav').superfish({
        //add options here if required
    });

    $(window).resize(function () {
        $('.pageheader--placeholder').height($('.pageheader').height());
    });

    var delta = 5;
    var didScroll;
    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    setTimeout(() => {
      // h1 Elemente ersetzen
      const h1Elements = document.querySelectorAll('h1[id^="modalTitle-"]');
      h1Elements.forEach(h1Element => {
        const h2Element = document.createElement('h2');
        Array.from(h1Element.attributes).forEach(attr => {
          h2Element.setAttribute(attr.nodeName, attr.nodeValue);
        });
        h2Element.textContent = h1Element.textContent;
        h1Element.parentNode.replaceChild(h2Element, h1Element);
      });

      // Aussagekräftiger Titel
      let videos = document.querySelectorAll('.video-js-box');
      videos.forEach(video => {
        let playBtn = video.querySelector('.able-big-play-button');
        let playBtn2 = video.querySelector('.able-button-handler-play');
        let title = playBtn.getAttribute('aria-label')+': '+video.querySelector('.video-title').innerHTML;
        playBtn.setAttribute('aria-label', title);
        playBtn2.setAttribute('aria-label', title);
      });
    }, 1500);


    function hasScrolled() {
        var st = $(this).scrollTop();

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop) {
            // Scroll Down
            $('body').removeClass('scrolled-up').addClass('scrolled-down');
        } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
                $('body').removeClass('scrolled-down').addClass('scrolled-up');
            }
        }

        lastScrollTop = st;
    }

    $(window).resize();


  // --- SUCHE FRÜHE HILFEN ---

  let $autocompleteElement = $('#wco_network_db-search');
  let ajaxUrl = $autocompleteElement.attr('data-ajax-load-url');
  let searchvalue = $.trim($('#wco_network_db-search').val());

  $autocompleteElement.autocomplete({
    source: function( request, response ) {
      // Fetch data
      $.ajax({
        url: ajaxUrl,
        type: 'post',
        dataType: "json",
        data: {
          'tx_wconetworkdb_pi1[term]': request.term
        },
        success: function( data ) {
          response( data );
        }
      });
    },
    select: function (event, ui) {
      $autocompleteElement.val(ui.item.label);
      return false;
    },
    focus: function(event, ui){
      $autocompleteElement.val(ui.item.label);
      return false;
    },
    minLength: 2
  })

  if(searchvalue){
    $('html, body').animate({
      scrollTop: $("#wco-networkdb-search").offset().top
    }, 1500);
  }
});
